import * as React from 'react';
import FormView from 'components/FormView';
import { IInvoiceSlipsFields } from '../interfaces';

class InvoiceSlips extends React.PureComponent<IInvoiceSlipsFields> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/sales-invoice-enquiry/pick-slips-by-despatch':
          onInitialLoad('PickSlipsByDespatch');
          break;
        case '/sales-invoice-enquiry/pick-slips-by-product':
          onInitialLoad('PickSlipsByProduct');
          break;
        default:
          onInitialLoad('InvoiceDetails');
      }
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, initialValues, operationMode, isLoading, summaryTableRenderer } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={initialValues}
          operationMode={operationMode}
          enableReinitialize={true}
          summaryTableRenderer={summaryTableRenderer}
        />
      </React.Fragment>
    );
  }
}

export default InvoiceSlips;
